/**
 * Returns true if id is a non-empty resident ID (not null, undefined, '', or the string 'undefined').
 * Used to guard API calls and queries that require a valid resident context.
 *
 * @param {*} id - Resident ID from route params or payload
 * @returns {boolean}
 */
export const isValidResidentId = (id) =>
  id != null && id !== '' && String(id) !== 'undefined';
